module.exports = __webpack_public_path__ + "img/basic-info.2e4795a7.jpg";